import React from "react";
import { Box, Heading, Stack, Text } from "@origin-digital/ods-core";
import { content } from "./content";

type NoSuggestionsProps = {
  query: string;
};

export const NoSuggestions: React.FC<NoSuggestionsProps> = ({ query }) => (
  <Box data-id="search-no-suggestions" padding="medium">
    <Stack space="small">
      <Box display="flex" justifyContent="center">
        <img
          data-id="search-no-suggestions-pictogram"
          src={content.noResultsImageUrl}
          width="96"
          height="96"
          alt=""
        />
      </Box>
      <Heading variant="h3" align="center">
        {content.noResultsTemplate(query)}
      </Heading>
      <Text align="center">{content.noResultsRetry}</Text>
    </Stack>
  </Box>
);
